import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class DegreeFinderSearchServiceSettings {
  baseUrl: string;
  searchTimeOut: number;
  b2cFlag: boolean;
}

const createInstance = (settings: DegreeFinderSearchServiceSettings): AxiosInstance =>
  axios.create({
    baseURL: settings.baseUrl,
    timeout: settings.searchTimeOut,
    method: `GET`,
  });

export const getDegreeFinderSearchResults = (
  searchQuery: string,
  signal: AbortSignal,
  settings: DegreeFinderSearchServiceSettings,
): Promise<AxiosResponse> => {
  const searchServicePath = `/ChoiceProgression/search?${searchQuery}`;

  const params: AxiosRequestConfig = {
    url: searchServicePath,
    signal,
  };
  return createInstance(settings).request(params);
};
